/**
 * Age Gate Modal
 * Handles age verification modal with cookie-based persistence
 */

class AgeGate {
  constructor() {
    this.cookieName = 'age_verified';
    this.cookieDays = 7;
    this.modal = document.getElementById('age-gate-modal');
    
    if (!this.modal) return;
    
    this.confirmButton = this.modal.querySelector('[data-age-gate-action="confirm"]');
    this.declineButton = this.modal.querySelector('[data-age-gate-action="decline"]');
    
    this.init();
  }
  
  /**
   * Initialize the age gate
   */
  init() {
    // Check if user has already verified
    if (this.getCookie(this.cookieName)) {
      this.hide();
      return;
    }
    
    // Show the modal
    this.show();
    
    // Set up event listeners
    this.setupEventListeners();
  }
  
  /**
   * Set up event listeners
   */
  setupEventListeners() {
    // Confirm button (Yes)
    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', () => this.handleConfirm());
    }
    
    // Decline button (No)
    if (this.declineButton) {
      this.declineButton.addEventListener('click', () => this.handleDecline());
    }
    
    // Prevent closing via ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isVisible()) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
  
  /**
   * Handle confirm action (Yes button)
   */
  handleConfirm() {
    // Set cookie for 7 days
    this.setCookie(this.cookieName, 'true', this.cookieDays);
    
    // Hide modal
    this.hide();
  }
  
  /**
   * Handle decline action (No button)
   */
  handleDecline() {
    const redirectUrl = this.declineButton.getAttribute('data-age-gate-url');
    
    if (redirectUrl && redirectUrl.trim() !== '') {
      window.location.href = redirectUrl;
    } else {
      // If no URL is set, just prevent access
      alert('You must be of legal age to access this website.');
    }
  }
  
  /**
   * Show the modal
   */
  show() {
    if (!this.modal) return;
    
    this.modal.style.display = 'block';
    document.body.classList.add('age-gate-active');
    
    // Focus on the confirm button for accessibility
    setTimeout(() => {
      if (this.confirmButton) {
        this.confirmButton.focus();
      }
    }, 100);
  }
  
  /**
   * Hide the modal
   */
  hide() {
    if (!this.modal) return;
    
    this.modal.classList.add('hidden');
    document.body.classList.remove('age-gate-active');
    
    // Fully remove from display after animation
    setTimeout(() => {
      this.modal.style.display = 'none';
    }, 300);
  }
  
  /**
   * Check if modal is visible
   */
  isVisible() {
    return this.modal && 
           this.modal.style.display !== 'none' && 
           !this.modal.classList.contains('hidden');
  }
  
  /**
   * Set a cookie
   */
  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/;SameSite=Lax';
  }
  
  /**
   * Get a cookie value
   */
  getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }
}

// Initialize age gate when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new AgeGate();
  });
} else {
  new AgeGate();
}

